import { AbstractCollection } from '../../abstract/Collection';
import { AbstractDocument, Identifiable, Timestampable, Untrackable } from '../../abstract/Document';
import { type Wedding, Weddings } from '../Weddings';
import type { IUser } from './Users.types';

@Identifiable
@Timestampable
@Untrackable
export class User extends AbstractDocument<IUser> {
  readonly collections = {};
}

export class Users extends AbstractCollection<User, IUser> {
  static path = 'users';

  constructor(document: Wedding) {
    super(document.collection(Users.path), User);
  }

  get wedding() {
    return Weddings._.getById(this.reference.parent!.id);
  }

  /**
   * Returns whether the provided user is a member of this wedding.
   *
   * @param user User ID
   */
  async isMember(user: IUser['id']) {
    try {
      return (await this.getById(user).get(false)).exists();
    } catch (error) {
      return false;
    }
  }
}
